import React, {useState, useEffect} from 'react';
import { Button, Typography, makeStyles, Select, FormControl, InputLabel, Grid, Card } from '@material-ui/core'; 
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import UserManagementPageApis from "../services/UserManagementPageServices";
import ExpandMoreStyledIcon from "../../../common-components/expandMoreStyledIcon/expandMoreStyledIcon";
const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: window.innerWidth/2.8,
    padding: theme.spacing(5),
  },
  formField: {
    marginBottom: theme.spacing(2),
    backgroundColor: 'white', // Same background color as in LogIn component
    width: 300
  },
  drawerHeader: {
    marginBottom: theme.spacing(1),
  },
  partDetails: {
  color: '#194cab',
  opacity: 1,
  fontFamily: 'Barlow',
  fontSize: 22,
  },
  partSubDetails: {
    color: '#b9b8b8',
    opacity: 1,
    fontWeight: 400,
    fontSize: 14,
    letterSpacing: 0.14,
    fontStyle: 'italic',
  },
  proceed: {
    "&:hover": {
      opacity: 1,
    },
    background:
      "transparent linear-gradient(90deg, #0055A4 0%, #0079E6 100%) 0% 0% no-repeat padding-box",
    borderRadius: 15,
    font: 'Barlow',
    opacity: .8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none",
  },
  cancelButton: {
    marginTop: theme.spacing(1),
    background: "transparent linear-gradient(90deg, #bebfc046 0%, #bebfc046 100%) 0% 0% no-repeat padding-box",
    borderRadius: 15,
    font: "Barlow",
    opacity: 0.8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none",
  },
}));



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AssignGrandparentAccDialogBox = ({open, onClose, selectedUser}) => {
  const userManagementPageApi = new UserManagementPageApis();
  const classes = useStyles();
  const [grandparentAccountList, setGrandparentAccountList] = useState([]);
  const [grandParentAccountId, setGrandparentAcctId] = useState(0);
  
  useEffect(() => {
    userManagementPageApi.getGrandparentAccountList().then((response) => {
      if (response?.model?.length > 0)
        setGrandparentAccountList(response?.model)
        setGrandparentAcctId(response?.model[0]?.grandParentAccountId);
    })  
  },[]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setGrandparentAcctId( value );
  };
  let grandparentList =
  grandparentAccountList.length > 0 &&
  grandparentAccountList.map((user, i) => {
    return (
      <option key={user.grandParentAccountId} value={user.grandParentAccountId}>
        {user.grandParentAccountId}: {user.grandParentAccountName} 
      </option>
    );
  }, this);

  const assignGrandparentAccount = () => {
    let data = {
      username: selectedUser.userId,
      grandParentAccountId: grandParentAccountId
    }
    userManagementPageApi.assignGrandparentAccount(data).then((response) => {
      if (response?.status === 200 || response.message.includes("successfully")) {
        alert("Grandparent Account assigned successfully");
        onClose();
        window.location.reload();
      } else {
        alert(`${response?.data?.message}. Please contact EmTrack support team.`);
      }
    })
  }

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"md"}
      >
        <DialogContent>

            <Grid container>
        <Grid item sm={12}>
          <Typography variant="h5" className={classes.partDetails}>
            ASSIGN GRANDPARENT ACCOUNT
          </Typography>
        </Grid>
        <Grid item sm={12}>
        <span style={{fontStyle:'italic', color:'grayText'}} className={classes.partSubDetails}>Grandparent Account act as the main account of multiple list of parent account. Please verify the user you want to assign with Grand Parent Account.</span>
        </Grid>
        <Grid item sm={5} style={{marginTop:15}}>
          <Card padding={2} style={{padding: 10}}>
            <Grid item sm={2}>
              <AccountBoxIcon style={{fontSize: 30, color:'0055A4'}} />
            </Grid>
            <Grid item sm={7}>
              <Typography variant="button" display="block" gutterBottom>
                User ID: {selectedUser?.userId}
              </Typography>
              <Typography variant="button" display="block" gutterBottom>
                Name: {selectedUser?.firstName} {selectedUser?.lastName}
              </Typography>
              <Typography variant="button" display="block" gutterBottom>
                User Role: {selectedUser?.userRole}
              </Typography>
              <Typography variant="button" display="block" gutterBottom>
                Current GP Acc ID: {selectedUser?.grandParentAccountId}
              </Typography>
            </Grid>
  
          </Card>
        </Grid>
        <Grid item sm={6} style={{marginTop:15, marginLeft: 20}}>
        <FormControl variant="outlined" className={classes.formField} style={{marginTop:10}}>
        <InputLabel id="user-measurement-system-label">Grandparent </InputLabel>
        <Select
            native
            label="Grandparent"
            className="sub-edit-textbox"
            IconComponent={ExpandMoreStyledIcon}
            value={grandParentAccountId}
            name="grandParentAccountId"
            onChange={handleChange}
          >
            {grandparentList}
          </Select>
          </FormControl>
        </Grid>
        
      </Grid>

        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="gray">
            Close
          </Button>
          <Button color="primary" className={classes.proceed} onClick={assignGrandparentAccount}>
            Assign
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AssignGrandparentAccDialogBox;